import i18n from 'i18n';

const typeMap: any = {
  CD: i18n.t('warrant.case.form.dataOnly'),
  CC: i18n.t('warrant.case.form.contentOnly'),
  ALL: i18n.t('warrant.case.form.dataContent'),
  PEN: i18n.t('warrant.case.form.pesRegister'),
  TRACE: i18n.t('warrant.case.form.trapTrace'),
};

const typeFormatter = (data: any) => {
  const type = typeMap[data.value];
  return type || '';
};

const targetFormatter = (data: any) => {
  const targets = data.value;
  let targetsString = '';
  if (!targets || !targets.length) return targetsString;
  targets.forEach((target: any) => {
    const value = target.primaryValue || target.secondaryValue;
    if (value) {
      targetsString = `${targetsString}, ${value}`;
    }
  });
  targetsString = targetsString.substring(1);
  return targetsString;
};

const casesColumnDefs = [
  {
    headerName: i18n.t('warrant.case.grid.name'),
    field: 'liId',
    suppressMenu: true,
    filter: 'text',
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.targets'),
    field: 'targets',
    valueFormatter: targetFormatter,
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.cf'),
    field: 'cfId.name',
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.startTime'),
    field: 'startDateTime',
    cellRenderer: 'datetimeCellRenderer',
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.stopTime'),
    field: 'stopDateTime',
    cellRenderer: 'datetimeCellRenderer',
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.timeZone'),
    field: 'timeZone',
    sortable: false,
    editable: false,
    cellRenderer: 'TimeZoneCellRenderer',
  },
  {
    headerName: i18n.t('warrant.case.grid.type'),
    field: 'type',
    valueFormatter: typeFormatter,
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.status'),
    field: 'status',
    editable: false,
  },
  {
    headerName: i18n.t('warrant.case.grid.action'),
    field: 'action',
    editable: false,
    cellRenderer: 'caseActionRenderer',
    width: 100,
  },
];

export default casesColumnDefs;
